"use client"

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

/**
 * MetricsNavigationProbe
 *
 * Measures SPA navigation duration using the 'nav-start' mark placed in
 * instrumentation-client.ts via onRouterTransitionStart(). When the pathname
 * changes (i.e., new route committed), we mark 'nav-end' and measure the
 * interval as 'nav'. Measurements are later flushed by instrumentation-client.ts.
 */
export default function MetricsNavigationProbe() {
    const pathname = usePathname()
    const lastPathRef = useRef<string | null>(null)

    useEffect(() => {
        if (lastPathRef.current === null) {
            lastPathRef.current = pathname
            return
        }
        if (lastPathRef.current === pathname) return

        try {
            performance.mark('nav-end')
            performance.measure('nav', 'nav-start', 'nav-end')
        } catch {
            // swallow if marks missing
        }

        lastPathRef.current = pathname
    }, [pathname])

    return null
}


